export const threePlayPluginChangeDefaults = () => {
  const setAriaLabel = (selector, label) => {
    const element = document.querySelector(selector);
    if (element) {
      element.ariaLabel = label;
    }
  };

  const overwriteAttributes = () => {
    setAriaLabel(
      `.mycroft-audio-description-snippet-toggle`,
      'Audio description',
    );
    setAriaLabel('.mycroft-equalizer-toggle', 'Equalize audio description');
    setAriaLabel('.mycroft-vol-control', 'Audio description volume slider');
    setAriaLabel('.mycroft-audio-description-toggle', 'Mute audio description');
  };

  // Observer callback for the three play plugin target element
  const observeThreePlayTargetElements = (mutations, observer) => {
    mutations.forEach((mutation) => {
      const { addedNodes } = mutation;
      if (addedNodes.length) {
        addedNodes.forEach((addedNode) => {
          // The audio controls are added to the container element
          if (
            addedNode.nodeType === Node.ELEMENT_NODE &&
            addedNode.classList.contains('p3sdk-container')
          ) {
            overwriteAttributes();
          }
        });
      }
    });
    observer.disconnect();
  };

  const observer = new MutationObserver(observeThreePlayTargetElements);
  const p3sdkTargetElement = document.querySelector('.p3sdk-target');
  if (p3sdkTargetElement) {
    observer.observe(p3sdkTargetElement, { childList: true, subtree: true });
  }
};
